import React from 'react';

const TextInput = React.forwardRef(({ className, ...props }, ref) => {
  return (
    <input
      ref={ref}
      className={`form-control ${className || ''}`}
      {...props}
    />
  );
});

export default TextInput;
